// HM-305 demo: rendering shadcn-style components adattati palette warm.
// Routata in HM-307 a /dev/components.

import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  toast,
} from '@hotel-manager/ui/components';
import { Bell, ChevronDown, LogOut, UserCircle } from '@hotel-manager/ui/icons';

export function ComponentsDemo() {
  return (
    <TooltipProvider delayDuration={150}>
      <div className="min-h-screen bg-bg-base p-8 text-text-primary">
        <h1 className="text-3xl font-bold mb-2">Componenti shadcn-style</h1>
        <p className="text-text-secondary mb-8">
          SPEC v2.6: wrapper Radix UI con palette warm. Toaster e TooltipProvider montati una volta
          nel main.tsx.
        </p>

        <section className="mb-10">
          <h2 className="text-xl font-semibold mb-4">Button variants</h2>
          <div className="flex flex-wrap gap-3">
            <Button variant="primary">Primario CTA</Button>
            <Button variant="secondary">Secondario</Button>
            <Button variant="ghost">Ghost</Button>
            <Button variant="link">Link</Button>
            <Button variant="danger">Danger</Button>
            <Button variant="primary" size="sm">
              Small
            </Button>
            <Button variant="primary" size="lg">
              Large
            </Button>
            <Button variant="primary" disabled>
              Disabled
            </Button>
          </div>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold mb-4">Dialog</h2>
          <Dialog>
            <DialogTrigger asChild>
              <Button variant="primary">Apri dialog</Button>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>Conferma check-out</DialogTitle>
                <DialogDescription>
                  L&apos;ospite Mario Rossi sta lasciando la camera 304. Procedere con il pagamento
                  e la chiusura del soggiorno?
                </DialogDescription>
              </DialogHeader>
              <DialogFooter>
                <Button variant="ghost">Annulla</Button>
                <Button variant="primary">Conferma check-out</Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold mb-4">DropdownMenu</h2>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="secondary">
                <UserCircle size={18} />
                Mario Reception
                <ChevronDown size={16} />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuLabel>Account</DropdownMenuLabel>
              <DropdownMenuItem>
                <UserCircle size={16} className="text-text-secondary" />
                Profilo
              </DropdownMenuItem>
              <DropdownMenuItem>
                <Bell size={16} className="text-text-secondary" />
                Notifiche
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem>
                <LogOut size={16} className="text-state-guas" />
                <span className="text-state-guas">Esci</span>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold mb-4">Tooltip</h2>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button variant="ghost" size="icon">
                <Bell size={20} />
              </Button>
            </TooltipTrigger>
            <TooltipContent>3 notifiche non lette</TooltipContent>
          </Tooltip>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold mb-4">Tabs</h2>
          <Tabs defaultValue="mapping">
            <TabsList>
              <TabsTrigger value="mapping">Mapping</TabsTrigger>
              <TabsTrigger value="accessi">Tipo accessi</TabsTrigger>
              <TabsTrigger value="automazioni">Automazioni</TabsTrigger>
              <TabsTrigger value="test">Test</TabsTrigger>
            </TabsList>
            <TabsContent value="mapping" className="bg-bg-card rounded-lg p-6 shadow-hm-sm">
              Contenuto tab Mapping (esempio cluster 19 KNX foundation)
            </TabsContent>
            <TabsContent value="accessi" className="bg-bg-card rounded-lg p-6 shadow-hm-sm">
              Contenuto tab Tipo accessi
            </TabsContent>
            <TabsContent value="automazioni" className="bg-bg-card rounded-lg p-6 shadow-hm-sm">
              Contenuto tab Automazioni (cluster 20 visual builder)
            </TabsContent>
            <TabsContent value="test" className="bg-bg-card rounded-lg p-6 shadow-hm-sm">
              Contenuto tab Test &amp; simulazione
            </TabsContent>
          </Tabs>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-4">Toast</h2>
          <div className="flex flex-wrap gap-3">
            <Button
              onClick={() =>
                toast.success('Check-in completato', { description: 'Camera 304 - Mario Rossi' })
              }
            >
              Toast success
            </Button>
            <Button
              variant="danger"
              onClick={() =>
                toast.error('Driver KNX offline', { description: 'Riprovare tra qualche secondo' })
              }
            >
              Toast error
            </Button>
            <Button
              variant="secondary"
              onClick={() =>
                toast.info('Nuova prenotazione ricevuta', { description: 'Booking.com - 12/05' })
              }
            >
              Toast info
            </Button>
          </div>
        </section>
      </div>
    </TooltipProvider>
  );
}
